export default __webpack_public_path__ + "static/media/teacherIcon.a9767480.svg";